import axios from "axios";
import { waitForFirebaseUser } from "./firebaseAuthHelper";

const API_BASE = "https://modularobjects.com/mailserver/api/interior/parameters";
// za localhost po potrebi:
// const API_BASE = "http://localhost:3000/mailserver/api/interior/parameters";

async function authConfig() {
  const user = await waitForFirebaseUser();
  const token = await user.getIdToken();

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
}

const interiorParameterApi = {
  async listDefinitions() {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/definitions`, config);
    return data;
  },

  async listUnits() {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/units`, config);
    return data;
  },

  async listGroups() {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/groups`, config);
    return data;
  },

  async createDefinition(payload) {
  const config = await authConfig();
  const { data } = await axios.post(`${API_BASE}/definitions`, payload, config);
  return data;
},

async updateDefinition(id, payload) {
  const config = await authConfig();
  const { data } = await axios.put(`${API_BASE}/definitions/${id}`, payload, config);
  return data;
},

async deleteDefinition(id) {
  const config = await authConfig();
  const { data } = await axios.delete(`${API_BASE}/definitions/${id}`, config);
  return data;
},

async createUnit(payload) {
  const config = await authConfig();
  const { data } = await axios.post(`${API_BASE}/units`, payload, config);
  return data;
},

async updateUnit(id, payload) {
  const config = await authConfig();
  const { data } = await axios.put(`${API_BASE}/units/${id}`, payload, config);
  return data;
},

async deleteUnit(id) {
  const config = await authConfig();
  const { data } = await axios.delete(`${API_BASE}/units/${id}`, config);
  return data;
},

async createGroup(payload) {
  const config = await authConfig();
  const { data } = await axios.post(`${API_BASE}/groups`, payload, config);
  return data;
},

async updateGroup(id, payload) {
  const config = await authConfig();
  const { data } = await axios.put(`${API_BASE}/groups/${id}`, payload, config);
  return data;
},

async deleteGroup(id) {
  const config = await authConfig();
  const { data } = await axios.delete(`${API_BASE}/groups/${id}`, config);
  return data;
},
};

export default interiorParameterApi;